import { useEffect } from 'react';

/**
 * Ask search engines not to index this page (the per-dealership sign-in at
 * /login/<slug>), and put <head> back as it was on leaving, so the landing
 * page stays indexable.
 */
export default function useNoIndex() {
    useEffect(() => {
        let meta = document.head.querySelector('meta[name="robots"]');
        const created = !meta;
        const previous = meta ? meta.getAttribute('content') : null;
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', 'robots');
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', 'noindex');
        return () => {
            if (created) meta.remove();
            else meta.setAttribute('content', previous);
        };
    }, []);
}
